export const AXIOS_CONFIG = {
    ENDPOINT: 'api/v1/sponsored-products/products',
    TIMEOUT: 300,
};

export default {
    AXIOS_CONFIG,
};
